export default class Hero {
  constructor(component) {
    this.dom = {
      $component: component,
      $link: component.querySelector('.js-ctaUrl'),
    }
    this.state = {

    }
    this.redirectHandler = this.redirect.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const { dom } = this
    dom.$component.addEventListener('click', this.redirectHandler)
  }

  redirect() {
    const { dom } = this
    const ctaUrl = dom.$link.dataset.ctaUrl

    if (ctaUrl) {
      window.location.href = ctaUrl
    }
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.Hero = this
  }
}
